import axios from '@/axios'
import * as types from '../mutation-types'
export default {
    namespaced: true,

    state: {
        remindersTypes: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/reminder/type').then(({ data }) => {
                commit(types.STORE_REMINDERS_TYPES, data);
                return data;    
            })
        },

        create(_, { name }) {
            return axios.post('/reminder/type', name, { headers: { 'content-type': 'application/json' } });
        },
        update(_, { id, name }) {
            return axios.put(`/reminder/type/${id}`, name, { headers: { 'content-type': 'application/json' } });
        },
        delete(_, { id }) {
            return axios.delete(`/reminder/type/${id}`);
        },
    },

    mutations: {
        [types.STORE_REMINDERS_TYPES](state, remindersTypes) {
            state.remindersTypes = remindersTypes;
        }
    },

    getters: {
        getReminderTypeById: state => id => state.remindersTypes.find(c => c.id === id)
    }
}